import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHearts } from 'src/hook/data/useHearts';
import { useBackHandler } from 'src/hook/global/useBackHandler';
import usePopUp from 'src/hook/modal/usePopUp';
import { HeartType } from 'src/model/enum/enums';
import useUser from '../../../../hook/data/useUser';
import { GetRazorSiteUrl } from '../../../../utils/URLUtils';
import { IFrame } from '../../../ui/GlobalComponents/IFrame/IFrame';
import { PageHeader } from '../../../ui/GlobalComponents/PageHeader/PageHeader';
import styles from './AddFriend.module.scss';

export const AddFriend = () => {
    const { userInfo, isProUser } = useUser();
    const { addHeart } = useHearts();
    const { showHeartPopUp } = usePopUp();
    const navigate = useNavigate();
    const handleBack = useBackHandler();

    useEffect(() => {
        if (isProUser()) return;
        const handleMessage = (event: MessageEvent) => {
            if (event.data.type === 'USER_MESSAGE') {
                const message = event.data.message.toLowerCase();
                console.log(message);
                if (message === 'success-add-friend') {
                    addHeart(HeartType.Friend);
                    navigate('/challenges');
                    setTimeout(() => {
                        showHeartPopUp(HeartType.Friend);
                    }, 1000);
                }
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [addHeart, isProUser, showHeartPopUp, navigate]);

    return (
        <div className={styles.addFriend}>
            <PageHeader title="Add a Friend" handleBackClick={() => handleBack()} />
            <IFrame
                src={GetRazorSiteUrl('profile/add-friend', userInfo?.Token)}
                title="Add a Friend"
            />
        </div>
    );
}; 